import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'src/app-redux/rtkq.interceptor';
import { partnerVerificationsTag } from 'src/app-redux/rtkq.tags';
import { transformResponses } from 'src/app-redux/rtkq.interceptor';
import { apiResources } from 'src/common/Constants';
import type { WithRequired } from 'src/common/types/UtilityTypes.type';
import type { PartnerDocument, UploadDocumentArgs } from 'src/management/PartnerDocuments';

const documentsTag = 'documents';

/** RTK Query API slice for partner document management endpoints. */
export const documentsApi = createApi({
  reducerPath: 'documentsApi',
  tagTypes: [documentsTag, partnerVerificationsTag],
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    /** Query to fetch all documents for a user by user ID. */
    fetchAllDocuments: builder.query<PartnerDocument[], number>({
      query: (userId) => `${apiResources.userDocuments}/${userId}/all`,
      providesTags: [documentsTag, partnerVerificationsTag],
      ...transformResponses,
    }),
    /** Mutation to upload a document for a user. */
    uploadDocument: builder.mutation<string, WithRequired<UploadDocumentArgs, 'documentTitle' | 'file'>>({
      query: (body) => {
        const formData = new FormData();
        for (const key in body) {
          if (Object.prototype.hasOwnProperty.call(body, key)) {
            const element = body[key as keyof typeof body];
            formData.append(key, element as any);
          }
        }
        return {
          url: `${apiResources.userDocuments}/upload`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (_result, error) => (error ? [] : [documentsTag]),
      ...transformResponses,
    }),
  }),
});

/** RTK Query hooks for partner document management endpoints. */
export const { useFetchAllDocumentsQuery, useUploadDocumentMutation } = documentsApi;
